<ion-header>
  <ion-toolbar>

    <ion-button style="font-size: 11px;" slot="end" class="back" fill="solid" (click)="cancel()">
      <ion-icon slot="start" name="close-circle-outline"></ion-icon>
      {{'General.Cancel' | translate }}
    </ion-button>

    <ion-title class="modal-title">{{ title | translate }}</ion-title>
  </ion-toolbar>
</ion-header>

<ion-content class="option" (click)="track($event)">

  <div class="image-container" #imageContainer>
    <div class="media-header media-view">
      <h1 class="title-retail">{{option.name.translations[translationService.getLanguage()]}}</h1>
    </div>

    <!-- ImagesforeveryColor -->
    <div class="item-image-container2" >
      @if (selectedColorImage.otherImages.length>0) {
        <div class="small-images" >
          @for (img of selectedColorImage.otherImages; track img; let i = $index) {
            <div class="image-parent style" >
              <img class="img2" [class.style2]="i==0" #img2 [id]="i" (click)="changeImage(img, $event)" [src]="getColorImages(img)" >
            </div>
          }
        </div>
      }

      @if (selectedColorImage.otherImages.length>0 && selectedImage) {
        <div (click)="zoom()" class="item-image">
          <ion-content class="ion-padding" scroll-y="false">
            <!--
            <ion-slides (ionSlideDidChange)="onSlideChange()" #slider>
              <ion-slide *ngFor="let img of selectedColorImage.otherImages;let i=index">
                <div class="slide">
                  <img [src]="getColorImages(img)" >
                </div>
              </ion-slide>
            </ion-slides>
            -->
            <!--
            <swiper
              #swiper
              (slideChange)="onSlideChange()"
              [slidesPerView]="1"
              [spaceBetween]="10"
              >
              <ng-template swiperSlide *ngFor="let img of selectedColorImage.otherImages; let i = index">
                <div class="slide">
                  <img [src]="getColorImages(img)">
                </div>
              </ng-template>
            </swiper>
            -->
            <swiper-container
              #swiper
              slides-per-view="1"
              space-between="10"
              (slidechange)="onSlideChange()"
              >
              @for (img of selectedColorImage.otherImages; track img; let i = $index) {
                <swiper-slide>
                  <div class="slide">
                    <img [src]="getColorImages(img)" />
                  </div>
                </swiper-slide>
              }
            </swiper-container>
          </ion-content>
        </div>
      }
    </div>

    <div class="additional-info">
      <!--<div class="header full-view">
      <h1 class="title-retail">{{option.name.translations[translateService.currentLang]}}</h1>
      <ng-container *ngIf="!combinationPrice">  <span class="price">{{option.price | currency:'USD':'symbol':'1.2-2'}} CAD</span><br></ng-container>
      <ng-container *ngIf="combinationPrice"><span class="price" >{{combinationPrice | currency:'USD':'symbol':'1.2-2'}} CAD</span></ng-container>
      <span style="font-size: 11px; color: gray; font-weight: bold;" *ngIf="itemQuantity>0">({{itemQuantity}} {{'Menu.InStock' | translate}} )</span>
      <span style="font-size: 11px; color: gray; font-weight: bold;" *ngIf="itemQuantity<=0 && option.isInventoryExist && option.isInventoryActive && isCombination">{{'Menu.OutOfStockTitle' | translate}}</span>
    </div>

    <hr class="line full-view">-->

    <div class="additional-details">
      <div class="show">
        @if (!selectedColor) {
          <span class="collection selectedColor">{{'Order.Colors' | translate}}</span>
        }
        @if (selectedColor) {
          <span class="collection selectedColor" >{{selectedColor}}</span>
        }
      </div>
      <div class="colors">
        @for (color of option.itemColors; track color; let i = $index) {
          @if (!color.isDeleted) {
            <div class="colorCircle" #colorCircle (click)="changeColor(color.name,color, $event)" [id]="color.id">
              @if (color.colorImage != null && color.colorImage !='' ) {
                <div class="color colorImage" [id]="color.id"  [style.background-image]="getColorImage(color)" ></div>
              }
              @if (color.code && (color.colorImage == null || color.colorImage =='')) {
                <div class="color" [id]="color.id" [style.background]="color.code"  ></div>
              }
              @if (!color.code && (color.colorImage == null || color.colorImage =='')) {
                <div class="color" [id]="color.id" alt=""></div>
              }
            </div>
          }
        }
      </div>

      <div class="price-quantity media-view">
        @if (!combinationPrice) {
          <span class="price">{{option.price | currency:'USD':'symbol':'1.2-2'}}</span>
        }
        @if (combinationPrice) {
          @if (!priceModifier) {
            <span class="price">
              {{combinationPrice | currency:'USD':'symbol':'1.2-2'}}
            </span>
          }
          @if (priceModifier) {
            <span class="price" >
              <span style="text-decoration: line-through;">{{combinationPrice | currency:'USD':'symbol':'1.2-2'}}</span>
              <span style="color: orange; margin-left: 0.5rem;">{{ priceModifier | currency:'USD':'symbol':'1.2-2'}}</span>
            </span>
          }
        }
        @if (itemQuantity>0) {
          <span style="font-size: 11px; color: gray; font-weight: bold; margin-left: 0.25rem;">({{itemQuantity}} {{'Menu.InStock' | translate}} )</span>
        }
        @if (itemQuantity<=0 && option.isInventoryExist && option.isInventoryActive && isCombination) {
          <span style="font-size: 11px; color: gray; font-weight: bold; margin-left: 0.25rem;">{{'Menu.OutOfStockTitle' | translate}}</span>
        }
      </div>

      <hr class="line media-view">

      <div class="size">
        <div class="size-lbl">{{'Order.Size' | translate}}</div>
        <div class="different-sizes">
          @for (s of option.itemSizes; track s; let i = $index) {
            @if (!s.isDeleted) {
              <div class="sizes" #sizes [id]="s.id"  (click)="selectSize(s.abbreviation, $event)">
                <label [id]="s.id">{{s.abbreviation.translations[translationService.getLanguage()]}}</label>
              </div>
            }
          }
        </div>
      </div>

      <div class="error" [hidden]="!postError">
        <ion-text color="danger">
          <h6 class="error-message">{{'Order.PleaseSelectSize' | translate}}</h6>
        </ion-text>
      </div>

      <div class="add-cart">
        <div class="qty">
          <label>Qty:&nbsp;</label>
          <select (change)="quantityChange($event)" [(ngModel)]="selectedQuantity" required>
            @for (qty of quantity; track qty) {
              <option [value]="qty">{{qty}}</option>
            }
          </select>
        </div>

        <div class="carts">
          <button class="cart"  (click)="onStartOrder()">{{'Order.AddCart' | translate}}</button>
        </div>
      </div>

      <div class="description">
        @if (option.itemDescription) {
          <div class="short-description">
            <button class="accordion" (click)="openAccordion($event)">{{option.itemDescription.title.translations[translationService.getLanguage()]}}</button>
            <div class="panel hide" [innerHTML]="sanitizer.bypassSecurityTrustHtml(option.itemDescription.description.translations[translationService.getLanguage()])">
            </div>
          </div>
        }
        @if (option.descriptionExtended) {
          <div class="Long-description">
            <button class="accordion" (click)="openAccordion($event)">{{option.descriptionExtended.title.translations[translationService.getLanguage()]}}</button>
            <div class="panel hide" [innerHTML]="sanitizer.bypassSecurityTrustHtml(option.descriptionExtended.description.translations[translationService.getLanguage()])">
            </div>
          </div>
        }
        @if (settingService.configuration.shippingReturnPolicy) {
          <div class="shipping-return">
            <button class="accordion" (click)="openAccordion($event)">{{settingService.configuration.shippingReturnPolicy.title.translations[translationService.getLanguage()]}}</button>
            <div class="panel hide" [innerHTML]="sanitizer.bypassSecurityTrustHtml(settingService.configuration.shippingReturnPolicy.description.translations[translationService.getLanguage()])">
            </div>
          </div>
        }
      </div>
    </div>
  </div>
</div>

<div class="total-container">
  <ion-grid style="padding: 0;">
    <ion-row>
      <ion-col style="padding: 0;" size="4">
        <ion-grid>
          <ion-row>
            <ion-col>
              <ion-item lines="none" class="total ion-text-center">
                @if (!chosenItemDetailCombination) {
                  <ion-icon (click)="backOption()" class="chevron-back" name="chevron-back-outline"></ion-icon>
                }
                <ion-label>
                  {{ orderItem.price | currency }}
                </ion-label>
              </ion-item>
            </ion-col>
          </ion-row>
        </ion-grid>
      </ion-col>
      <ion-col>
        <div class="port">
          <ion-item  class="ion-text-center continue">
            <ion-label style="text-align:right; margin: 0px !important;">
              <ion-button style="color: black; transition: --ion-background-color 0.2s ease"
                (click)="skipOption();" fill="clear" >
                {{ 'General.Next' | translate }}
              </ion-button>
            </ion-label>
            <ion-icon name="chevron-forward-outline" item-right></ion-icon>
          </ion-item>
        </div>
      </ion-col>
    </ion-row>
  </ion-grid>
</div>

@if (selectedColorImage.otherImages.length>0) {
  <div #zoomIn class="zoom-in hide">
    <div class="zoom-container">
      @for (img of selectedColorImage.otherImages; track img) {
        <div class="small">
          <div [style.background-image]="zoomSmallImages(img)" ></div>
        </div>
      }
      <ion-icon (click)="close()" style="cursor: pointer;" name="close" class="close"></ion-icon>
      @for (img of selectedColorImage.otherImages; track img) {
        <img class="merchant-image" [src]="getColorImages(img)"  >
      }
    </div>
  </div>
}
</ion-content>